import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";

import { url } from "../../../../../Config/Config";
import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import AddFeeGroup from "../AddFeeGroup/AddFeeGroup";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class FeeGroupBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      editStatus: false,
      groupId: "",
    };
  }

  handleEdit = (groupId) => {
    this.setState({
      editStatus: true,
      groupId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDialogOpen = (groupId) => {
    this.setState({
      dialogOpen: true,
      groupId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteGroup = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/fee-groups/${this.state.groupId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Fees group deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getFeeGroup();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteGroup();
      }
    }
  };

  render() {
    const { classes, index, data } = this.props;
    return this.state.editStatus ? (
      <AddFeeGroup
        editStatus={true}
        data={data}
        handleCancelEdit={this.handleCancelEdit}
        getFeeGroup={this.props.getFeeGroup}
      />
    ) : (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.studentClass}</TableCell>
        <TableCell align="center">
          {data.faculty ? data.faculty : "N/A"}
        </TableCell>
        <TableCell align="center">{data.group ? data.group : "N/A"}</TableCell>
        <TableCell align="center">{data.fees.length}</TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Details"
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/Fees-Group/details/${data._id}`
              )
            }
          >
            <InfoIcon />
          </Tooltip>
          <Tooltip
            arrow
            title="Edit"
            className={classes.tooltip}
            onClick={() => this.handleEdit(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            arrow
            title="Delete"
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteGroup}
        />
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(FeeGroupBody)));
